<h1 mat-dialog-title>
  {{ 'COMMON.ORDER_DETAILS.UPLOAD_ATTACHMENTS' | translate }}
</h1>
<mat-dialog-content>
  <glxy-uploader
    #glxyUploader
    [autoUpload]="false"
    [uploadUrl]="data.uploadUrl"
    [maxFiles]="maxNumberFiles"
    [files]="files"
    (fileUploadErrored)="onError($event)"
    (fileUploaded)="onUpload($event)"
    (filesChanged)="onFilesChanged($event)"
  ></glxy-uploader>
  <glxy-uploader-list
    [files]="files"
    (fileDeleted)="glxyUploader.deleteFile($event)"
  ></glxy-uploader-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="null">
    {{ 'COMMON.ORDERS.CANCEL' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="files.length === 0 || (loading$$ | async) === true"
    (click)="onUploadAndClose()"
  >
    {{ 'COMMON.ORDERS.UPLOAD' | translate }}
  </button>
</mat-dialog-actions>
